export enum EGenre {
	MASCULIN = 'MASCULIN',
	FEMININ = 'FEMININ',
	NON_BINAIRE = 'NON_BINAIRE'
}
